__turbopack_context__.v({
  "button": "landing-logged-in-controls-module-scss-module__6lc1qa__button",
  "caret": "landing-logged-in-controls-module-scss-module__6lc1qa__caret",
  "icon": "landing-logged-in-controls-module-scss-module__6lc1qa__icon",
  "name": "landing-logged-in-controls-module-scss-module__6lc1qa__name",
  "open": "landing-logged-in-controls-module-scss-module__6lc1qa__open",
  "platform": "landing-logged-in-controls-module-scss-module__6lc1qa__platform",
  "root": "landing-logged-in-controls-module-scss-module__6lc1qa__root",
  "user_menu_trigger": "landing-logged-in-controls-module-scss-module__6lc1qa__user_menu_trigger",
});
